import AbstractService from "./abstract.service"
import AssetsService from "./assets.service"
import AccountDetailTransformer, { baseUri } from "@/transformers/accountDetail.transformer"
import { readFileAsBinary } from "./utils"

class AccountDetailService extends AbstractService {
  constructor() {
    super({ baseUri, transformer: AccountDetailTransformer })
  }

  async updateLogo(uuid, file) {
    let logo = null
    if (file) {
      const binary = await readFileAsBinary(file)
      const asset = await AssetsService.upload(binary)
      logo = asset.iri
    }

    return this.update(uuid, { payload: { logo } })
  }
}
const accountDetailService = new AccountDetailService()
export default accountDetailService
